import { useDeviceType } from '@libs/common-next';

import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';
import type { Tile6UpProps } from './types';
import './Tile6UpVisualNav.scss';

export default function Tile6UpVisualNav({ tiles, header, className, overrideDefaultClass }: Tile6UpProps) {
    const { isMobile } = useDeviceType();

    const classNameType = !isMobile && tiles.length < 6 ? 'xl-even-spacing' : '';

    return (
        <BuildContextProvider>
            <SixTileCarousel
                header={header}
                className={`${className || 'tile6up-visual-nav'} ${classNameType}`}
                {...{ overrideDefaultClass }}
                alignText="center"
                data-testid="six-tile-visual-nav"
                tiles={tiles}
                variant="VisualNav"
                breakpoints={{
                    960: {
                        perView: 5,
                        gap: 16,
                    },
                    560: {
                        perView: 3.5,
                        gap: 8,
                    },
                }}
            />
        </BuildContextProvider>
    );
}
